var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "MasterCard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, ">", _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2.182C0 .977.977 0 2.182 0h43.636C47.023 0 48 .977 48 2.182v29.09a2.182 2.182 0 01-2.182 2.183H2.182A2.182 2.182 0 010 31.273V2.182z",
    fill: "#262626"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.454 7.271H38.41v18.887H9.454z",
    opacity: 0.01
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5F00",
    d: "M20.114 10.562h7.639v12.304h-7.639z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.902 16.713a7.773 7.773 0 013.03-6.15c-3.253-2.522-7.924-2.154-10.731.843a7.745 7.745 0 000 10.617c2.807 2.997 7.478 3.365 10.731.844a7.773 7.773 0 01-3.03-6.154z",
    fill: "#EB001B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.026 21.366v.51h-.054v-.51h-.114v-.106h.289v.106h-.121zm.56-.106v.617h-.061v-.467l-.094.401h-.066l-.095-.4v.466h-.063v-.617h.088l.102.441.101-.44h.088zM36.77 16.711c-.001 2.996-1.736 5.729-4.468 7.038a8.025 8.025 0 01-8.37-.887 7.786 7.786 0 003.031-6.152c0-2.4-1.117-4.668-3.031-6.152a8.025 8.025 0 018.37-.887c2.733 1.31 4.467 4.042 4.467 7.038v.002z",
    fill: "#F79E1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.e86cfca3ce2924ed002dfaec36a0d1d2.svg";
export { ForwardRef as ReactComponent };